import {useMemo} from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import useKeywords from "../../hooks/useKeywords";
import {Grid, Tooltip, Typography} from "@material-ui/core";
import Cover from "./Cover";
import {isFunction, uniqBy} from "lodash"; 
import {filterList} from "../../utils/items"; 


const OPTIONS_LIMIT = 50;

const filterOptions = (options, state) => {
    const keyword = state.inputValue.trim().toLowerCase();
    return filterList(options, keyword).slice(0, OPTIONS_LIMIT)
}; 
// console.log(filterOptions)

export default function ItemsAutoComplete({value, onChange,size='small',minWidth=300, multiple = false,sx}) {
    const {keywords = [], loading} = useKeywords()

    const data = useMemo(()=>uniqBy(keywords,'name'),[keywords])

    const handleChange = (change) => {
        isFunction(onChange) && onChange(change)
    }

    // console.log(data) 

    return (
        <Autocomplete
            disablePortal
            options={data}
            sx={{
                ...(sx && {...sx}),
                minWidth,
                // overflowY: 'visible',
                // zIndex:'999999 !important'
                // zIndex:(theme)=>theme.zIndex.drawer +20000
            }}
            value={value}
            loading={loading}
            multiple={multiple}
            filterOptions={filterOptions}
            isOptionEqualToValue={(option, value)=>option?.id===value?.id}
            onChange={(event, value) => {
                handleChange(value);
            }}

            getOptionLabel={option => option?.name}

            renderOption={(props, option) => (
                <Grid container spacing={3} alignItems="center" {...props}>
                    <Grid item xs={2}>
                        <Cover src={option?.imageUrl}/>
                    </Grid>
                    <Grid item xs={10}>
                        <Tooltip placement="right" title={option?.name} arrow>
                            <Typography noWrap style={{fontSize: 12}}>
                                {option?.name}
                            </Typography>
                        </Tooltip>
                    </Grid>
                </Grid>
            )}

            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    size={size}
                    label="Rechercher..."
                />
            )}
        />
    )
}